// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var DefaultSortHandler = (function () {
    function DefaultSortHandler(defaultSortOptions) {
        this.fieldSortType = "Field";
        this.defaultSortOptions = defaultSortOptions;
    }
    DefaultSortHandler.prototype.addSortCriteriaToQuery = function (queryBuilder) {
        queryBuilder.sortCriteria = this.defaultSortOptions.defaultSortCriteriaLowercase;
        if (this.defaultSortOptions.defaultSortType === this.fieldSortType) {
            queryBuilder.sortField = this.defaultSortOptions.defaultSortField;
        }
    };
    return DefaultSortHandler;
}());
exports.__esModule = true;
exports["default"] = DefaultSortHandler;



//////////////////
// WEBPACK FOOTER
// ./Base/Sorts/DefaultSortHandler.ts
// module id = 7
// module chunks = 0